import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { computed, defineComponent, onBeforeUnmount, reactive, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Loading } from "@element-plus/icons";
import Head from "@/components/Head/index.vue";
import { useRoute } from "vue-router";
import { ArrowRight } from "@element-plus/icons";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import myVideo from "@/components/myVideo/index.vue";
import DownFileList from "@/components/DownFileList/index.vue";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
import router from "@/router";
export default defineComponent({
  name: "StudyDetail",
  components: {
    Head: Head,
    Loading: Loading,
    ArrowRight: ArrowRight,
    myVideo: myVideo,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var videos = ref("");
    var id = useRoute().query.newsId;
    var baseUrl = process.env.VUE_APP_BASE_URL;

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var loading = ref(false); // 数据列表信息

    var data = reactive({
      detail: {
        title: "",
        attachmentId: 0,
        durationState: 0,
        processId: null,
        status: 1,
        studyDuration: 0,
        studyTime: 0,
        download: 0,
        videoUrl: "1",
        newsId: 0
      },
      collect: false,
      collectClick: "addCollect",
      collectId: 0,
      number: 0,
      // download:0,
      dataId: id,
      startTime: 0,
      isReadyvideo: 1,
      initReadTime: 0,
      initStudyTime: 0,
      flag: false,
      dlist: [{
        attachmentId: ""
      }],
      promptFlag: true //是否弹提示信息

    });
    getTabledata();
    getCollect();

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } //计算进度


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, ids;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading.value = false;
                _context3.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getnewsDetail"](id);

              case 3:
                res = _context3.sent;

                if (res.code == 0) {
                  res.data.content = res.data.content.replace(/(<\/?a.*?>)/g, '');
                  data.detail = res.data;

                  if (!res.data.studyTime) {
                    data.detail.studyTime = res.data.studyDuration;
                  } else {
                    data.detail.studyTime = Number(data.detail.studyTime);
                  }

                  if (res.data.download) {
                    data.detail.download = res.data.download;
                  } else {
                    data.detail.download = 0;
                  }

                  data.initStudyTime = !data.detail.studyTime ? res.data.studyDuration : data.detail.studyTime;
                  videos.value = res.data.videoUrl ? process.env.VUE_APP_BASE_URL + res.data.videoUrl : "";

                  if (res.data.attachmentId) {
                    ids = data.detail.attachmentId ? data.detail.attachmentId : "";
                    downFileList.value && downFileList.value["showList"]({
                      type: "ids",
                      value: ids
                    });
                  } //const ids = data.detail.attachmentId ? data.detail.attachmentId : "";
                  // downFileList.value &&
                  //   downFileList.value["showList"]({
                  //     type: "ids",
                  //     value: ids,
                  //   });


                  data.number = data.detail.studyTime;
                  data.initReadTime = Math.trunc(data.detail.studyDuration - data.detail.studyTime);

                  if (data.detail.studyTime != 0) {
                    data.startTime = data.detail.studyDuration - data.detail.studyTime;
                    data.isReadyvideo = 1;
                  } else {
                    data.startTime = 0;
                    data.isReadyvideo = 2;
                  }

                  if (data.detail.durationState != 1 && data.detail.videoUrl == "") {
                    sendMsg();
                  }

                  changeInfoTotal(1, "\u5728\u7EBF\u5B66\u4E60\uFF1A".concat(data.detail.title), 3);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getTabledata.apply(this, arguments);
    }

    var percent = computed(function () {
      return function () {
        var a = Number(((data.detail.studyDuration - data.detail.studyTime) / data.detail.studyDuration).toFixed(2));
        return Math.round(a * 100);
      };
    }); //倒计时

    var clock;
    var canClick = ref(false);

    function sendMsg() {
      if (canClick.value) return;
      canClick.value = true;
      clock = window.setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var code;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data.number--;

                if (!(data.number <= 0)) {
                  _context.next = 9;
                  break;
                }

                window.clearInterval(clock);

                if (!(data.detail.studyTime != 0)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return updata(Math.trunc(data.detail.studyTime - data.number));

              case 6:
                code = _context.sent;

                // const code = await updateRecord();
                if (code == 0) {
                  data.detail.studyTime = 0;
                  data.detail.durationState = 1;
                }

              case 8:
                canClick.value = false;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 1000);
    }

    function secTotime(s) {
      var t = "";

      if (s > -1) {
        var min = Math.floor(s / 60);
        var sec = s % 60;

        if (min < 10) {
          t += "0";
        }

        t += min + ":";

        if (sec < 10) {
          t += "0";
        }

        t += sec.toFixed(0);
      }

      return t;
    } //获取是否下载


    function handleDow(val) {
      if (data.detail.download == 0) {
        data.detail.download = val;
        updata(0);
      }
    } //获取是否收藏


    function getCollect() {
      return _getCollect.apply(this, arguments);
    } //点击收藏


    function _getCollect() {
      _getCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                obj = {
                  category: 2,
                  type: 1,
                  contentId: id
                };
                _context4.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getCollect"](obj);

              case 3:
                res = _context4.sent;

                if (res.data) {
                  data.collect = true;
                  data.collectId = res.data.collectionId;
                  data.collectClick = "studyDeleteCollect";
                } else {
                  data.collect = false;
                  data.collectClick = "addCollect";
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getCollect.apply(this, arguments);
    }

    function handleCollect() {
      return _handleCollect.apply(this, arguments);
    } //点击暂停视频


    function _handleCollect() {
      _handleCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, _res;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(data.collectClick == "addCollect")) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[data.collectClick](JSON.stringify({
                  category: 2,
                  contentId: id,
                  type: 1,
                  title: data.detail.title
                }));

              case 3:
                res = _context5.sent;

                if (res.code == 0) {
                  data.collect = true;
                  ElMessage.success("收藏成功");
                  getCollect();
                  changeInfoTotal(1, "\u6536\u85CF\uFF1A".concat(data.detail.title), 4);
                } else {
                  ElMessage.success(res.msg);
                }

                _context5.next = 11;
                break;

              case 7:
                _context5.next = 9;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[data.collectClick](data.collectId);

              case 9:
                _res = _context5.sent;

                if (_res.code == 0) {
                  data.collect = false;
                  getCollect();
                  ElMessage.success("取消收藏成功");
                } else {
                  ElMessage.success(_res.msg);
                }

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _handleCollect.apply(this, arguments);
    }

    function handleVideo(_x, _x2) {
      return _handleVideo.apply(this, arguments);
    }

    function _handleVideo() {
      _handleVideo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(val, vals) {
        var code;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(data.detail.studyDuration - data.detail.studyTime != data.detail.studyDuration)) {
                  _context6.next = 6;
                  break;
                }

                data.initReadTime = val;
                _context6.next = 4;
                return updata(Math.trunc(data.detail.studyTime - (data.detail.studyDuration - val)));

              case 4:
                code = _context6.sent;

                // const res = await globalProperties?.$api["updateRecord"]({
                //   newsId: Number(id),
                //   processId: data.detail.processId,
                //   studyTime: Math.trunc(
                //     data.detail.studyTime - (data.detail.studyDuration - val)
                //   ),
                //   download: data.detail.download,
                // });
                if (code == 0) {
                  data.detail.studyTime = data.detail.studyDuration - Math.trunc(val);
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _handleVideo.apply(this, arguments);
    }

    var downFileList = ref(null); // //下载附件列表
    // async function download(val) {
    //   const lis = await globalProperties?.$api["download"](val);
    //   if (lis.code == 0) {
    //     data.dlist = lis.data;
    //     let ids = String(data.dlist[0].attachmentId);
    //     data.dlist.forEach((item, index) => {
    //       if (index != 0) {
    //         ids = ids + "," + String(item.attachmentId);
    //       }
    //     });
    //     downFileList.value &&
    //       downFileList.value["showList"]({
    //         type: "ids",
    //         value: ids,
    //       });
    //   }
    // }

    function test2(val, callback) {
      callback();
      IdowCollect(JSON.stringify({
        type: 2,
        title: data.detail.title,
        category: 2,
        contentId: data.detail.newsId
      }));
    }

    function IdowCollect(_x3) {
      return _IdowCollect.apply(this, arguments);
    } // })
    // 文章阅读时间修改
    // async function updateRecord() {
    //   const res = await globalProperties?.$api["updateRecord"]({
    //     newsId: Number(id),
    //     processId: data.detail.processId,
    //     studyTime: Math.trunc(data.detail.studyTime - data.number),
    //     download: data.detail.download,
    //   });
    //   if (res.code == 0) {
    //     data.detail.processId = res.data;
    //   } else {
    //     ElMessage.warning(res.msg == "error" ? "系统错误" : res.msg);
    //   }
    //   return res.code;
    // }
    // 更新函数


    function _IdowCollect() {
      _IdowCollect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(val) {
        var lis;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log(data.detail.download, 777777777777); // if(data.detail.download == 0){
                //   console.log(data.detail.download,232133333333333333);
                //   data.detail.download = 1;
                //   updata(0);
                // }

                _context7.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["collect"](val);

              case 3:
                lis = _context7.sent;

                if (lis.code == 0) {
                  ElMessage.success("下载成功");
                } else {
                  ElMessage.success(lis.msg);
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _IdowCollect.apply(this, arguments);
    }

    function updata(_x4) {
      return _updata.apply(this, arguments);
    } //视频


    function _updata() {
      _updata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(readTime) {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log(data.detail.download, 1111111111111);
                _context8.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["updateRecord"]({
                  newsId: Number(id),
                  processId: data.detail.processId,
                  studyTime: readTime,
                  download: data.detail.download
                });

              case 3:
                res = _context8.sent;

                if (!(res.code == 0)) {
                  _context8.next = 8;
                  break;
                }

                data.detail.processId = res.data;
                _context8.next = 11;
                break;

              case 8:
                if (!(readTime == 0)) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt("return");

              case 10:
                if (res.msg.includes("撤销")) {
                  ElMessage.warning(res.msg);
                  data.promptFlag = false;
                  router.back();
                } else if (!res.msg.includes("重复")) {
                  ElMessage.warning("系统错误");
                }

              case 11:
                return _context8.abrupt("return", res.code);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _updata.apply(this, arguments);
    }

    var videoRef = ref(); //添加地址

    if (window.history) {
      console.log("添加");
      history.pushState(null, "null", document.URL);
      window.addEventListener("popstate", back, false);
    } //返回


    function backTwo() {
      router.back();
    } // 返回


    function back() {
      return _back.apply(this, arguments);
    } // watch(
    //   () => data.detail.download,
    //   async () => {
    //     updata(0);
    //   }
    // );


    function _back() {
      _back = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var code, _code, _code2;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (data.detail.videoUrl != "") {
                  videoRef.value.add();
                }

                if (data.promptFlag) {
                  _context10.next = 6;
                  break;
                }

                router.go(-1);
                window.removeEventListener("popstate", back, false);
                window.clearInterval(clock);
                return _context10.abrupt("return", false);

              case 6:
                if (!(!!data.detail.attachmentId && data.detail.status != 2)) {
                  _context10.next = 34;
                  break;
                }

                if (!(data.detail.download == 0)) {
                  _context10.next = 23;
                  break;
                }

                if (data.detail.videoUrl) {
                  _context10.next = 19;
                  break;
                }

                if (data.detail.durationState) {
                  _context10.next = 16;
                  break;
                }

                _context10.next = 12;
                return updata(Math.trunc(data.detail.studyTime - data.number));

              case 12:
                code = _context10.sent;

                // const code = await updateRecord();
                if (code == 0) {
                  window.removeEventListener("popstate", back, false);
                }

                _context10.next = 17;
                break;

              case 16:
                //已完成学时
                window.removeEventListener("popstate", back, false);

              case 17:
                _context10.next = 20;
                break;

              case 19:
                //视频未下载附件
                window.removeEventListener("popstate", back, false);

              case 20:
                ElMessageBox.alert("您还没有下载附件,确定要退出吗?", "Warning", {
                  confirmButtonText: "确定",
                  showClose: false,
                  title: "提示",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          //文章未下载附件
                          router.go(-1);

                        case 1:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }))).catch(function () {
                  return false; //console.log(111);
                });
                _context10.next = 32;
                break;

              case 23:
                if (data.detail.durationState) {
                  _context10.next = 30;
                  break;
                }

                _context10.next = 26;
                return updata(Math.trunc(data.detail.studyTime - data.number));

              case 26:
                _code = _context10.sent;

                // const code = await updateRecord();
                if (_code == 0) {
                  router.go(-1);
                  window.removeEventListener("popstate", back, false);
                }

                _context10.next = 32;
                break;

              case 30:
                //已完成学时
                router.go(-1);
                window.removeEventListener("popstate", back, false);

              case 32:
                _context10.next = 42;
                break;

              case 34:
                if (!(data.detail.videoUrl == "" && data.detail.status != 2)) {
                  _context10.next = 40;
                  break;
                }

                _context10.next = 37;
                return updata(Math.trunc(data.detail.studyTime - data.number));

              case 37:
                _code2 = _context10.sent;

                if (_code2 == 0) {
                  router.go(-1);
                  window.removeEventListener("popstate", back, false);
                }

                return _context10.abrupt("return");

              case 40:
                // 视频
                router.go(-1);
                window.removeEventListener("popstate", back, false);

              case 42:
                window.clearInterval(clock);

              case 43:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
      return _back.apply(this, arguments);
    }

    onBeforeUnmount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              window.clearInterval(clock);
              window.removeEventListener("popstate", back, false);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    return {
      loading: loading,
      backTwo: backTwo,
      data: data,
      back: back,
      baseUrl: baseUrl,
      handleCollect: handleCollect,
      videos: videos,
      downFileList: downFileList,
      handleVideo: handleVideo,
      percent: percent,
      canClick: canClick,
      sendMsg: sendMsg,
      secTotime: secTotime,
      clock: clock,
      test2: test2,
      handleDow: handleDow,
      videoRef: videoRef
    };
  }
});